import React          from 'react';
import { useSidebar } from '../../providers/sidebar';
import classNames     from 'classnames';

const CloseButton = ({ label }) => {
  const { hideSidebar } = useSidebar();

  return (
    <button className={classNames('btn', 'primary')} onClick={hideSidebar}>
      {label}
    </button>
  );
};

export default CloseButton;
